export default "/static/webpack/media/big-five-diagram.nb.e63a5cda.svg";